import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/Api/ApiServices";

export const GetOneflowActionScientificCommitteeBySubTaskId = createAsyncThunk(
  "FlowActionScientificCommittee/GetOneflowActionScientificCommitteeBySubTaskId",
  async (parameters, { rejectWithValue }) => {
    try {
     
      const apiClient =  getApiClient();
      const response = await apiClient.post(
        "api/FlowActionScientificCommittee/GetOneflowActionScientificCommitteeBySubTaskId",
        parameters
      );

      const data = response.data.result; // Assuming response has a "data" field
      console.log(data, "app");
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const AddflowActionScientificCommittee = createAsyncThunk(
  "FlowActionScientificCommittee/AddflowActionScientificCommittee",
  async (parameters, { rejectWithValue }) => {
    try {
     
      const apiClient =  getApiClient();
      const response = await apiClient.post(
        "api/FlowActionScientificCommittee/AddflowActionScientificCommittee",
        parameters
      );

      const data = response.data.result; // Assuming response has a "data" field
      console.log(data, "app");
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);



const FlowActionScientificCommittee = createSlice({
  name: "FlowActionScientificCommittee",
  initialState: {
    //------------- GetOneFlowActionScientificCommittee ---------------------
    FlowActionScientificCommittee: {},
    loadingFlowActionScientificCommittee: false,
    errorFlowActionScientificCommittee: null,
    //------------- AddFlowActionScientificCommittee ---------------------
    AddFlowActionScientificCommittee: {},
    loadingAddFlowActionScientificCommittee: false,
    errorAddFlowActionScientificCommittee: null,
    
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetOneflowActionScientificCommitteeBySubTaskId.pending, (state, action) => {
        state.loadingFlowActionScientificCommittee = true;
        state.FlowActionScientificCommittee = action.payload;
        state.errorFlowActionScientificCommittee = null;
      })
      .addCase(GetOneflowActionScientificCommitteeBySubTaskId.fulfilled, (state, action) => {
        state.loadingFlowActionScientificCommittee = false;
        state.FlowActionScientificCommittee = action.payload;
      })
      .addCase(GetOneflowActionScientificCommitteeBySubTaskId.rejected, (state, action) => {
        state.loadingFlowActionScientificCommittee = false;
        state.FlowActionScientificCommittee = action.payload;
      });
   //----------------------AddflowActionScientificCommittee---------------------
     builder
      .addCase(AddflowActionScientificCommittee.pending, (state, action) => {
        state.loadingAddFlowActionScientificCommittee = true;
        state.AddFlowActionScientificCommittee = action.payload;
        state.errorAddFlowActionScientificCommittee = null;
      })
      .addCase(AddflowActionScientificCommittee.fulfilled, (state, action) => {
        state.loadingAddFlowActionScientificCommittee = false;
        state.AddFlowActionScientificCommittee = action.payload;
      })
      .addCase(AddflowActionScientificCommittee.rejected, (state, action) => {
        state.loadingAddFlowActionScientificCommittee = false;
        state.AddFlowActionScientificCommittee = action.payload;
      });
   
   
  },
});


export default FlowActionScientificCommittee.reducer;
